// src/services/studentService.jsx
import http from "./http";

/* --------------------------------
   ADD STUDENT
   POST /api/students?action=add
-------------------------------- */
export const addStudent = async (payload) => {
  try {
    const res = await http.post("students?action=add", {
      school_id: payload.school_id,
      name: payload.name,
      roll_no: payload.roll_no,
      student_class: payload.student_class,
      father_name: payload.father_name,
      contact: payload.contact,
      address: payload.address,
      image: payload.image, // Base64 or URL
    });
    return res.data;
  } catch (error) {
    return { status: "error", message: "Network Error: Could not connect to server" };
  }
};

/* --------------------------------
   UPDATE STUDENT
   POST /api/students?action=update
-------------------------------- */
export const updateStudent = async (id, payload) => {
  try {
    const res = await http.post("students?action=update", {
      id: id,
      school_id: payload.school_id,
      name: payload.name,
      roll_no: payload.roll_no,
      student_class: payload.student_class,
      father_name: payload.father_name,
      contact: payload.contact,
      address: payload.address,
      image: payload.image,
    });
    return res.data;
  } catch (error) {
    return { status: "error", message: "Network Error: Could not connect to server" };
  }
};

/* --------------------------------
   GET ALL STUDENTS FOR A SCHOOL
   POST /api/students?action=get&school_id=...
-------------------------------- */
export const getStudentsBySchool = async (schoolId) => {
  try {
    const res = await http.post(`students?action=get&school_id=${schoolId}`);
    return res.data;
  } catch (error) {
    return { status: "error", message: "Network Error: Could not connect to server" };
  }
};

/* --------------------------------
   GET SINGLE STUDENT
   POST /api/students?action=get&id=...
-------------------------------- */
export const getStudentById = async (id) => {
  try {
    const res = await http.post(`students?action=get&id=${id}`);
    return res.data;
  } catch (error) {
    return { status: "error", message: "Network Error: Could not connect to server" };
  }
};

/* --------------------------------
   DELETE STUDENT
   POST /api/students?action=delete
-------------------------------- */
export const deleteStudent = async (id) => {
  try {
    const res = await http.post("students?action=delete", {
      id: id,
    });
    return res.data;
  } catch (error) {
    return { status: "error", message: "Network Error: Could not connect to server" };
  }
};

/* --------------------------------
   GET ACTIVATION REQUESTS
   GET /api/school/get_activation_requests
-------------------------------- */
export const getActivationRequests = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    
    if (params.school_id) queryParams.append("school_id", params.school_id);
    if (params.student_account_status) queryParams.append("student_account_status", params.student_account_status);
    if (params.class_id) queryParams.append("class_id", params.class_id);
    if (params.search) queryParams.append("search", params.search);
    if (params.id_card_status) queryParams.append("id_card_status", params.id_card_status);
    if (params.from_date) queryParams.append("from_date", params.from_date);
    if (params.to_date) queryParams.append("to_date", params.to_date);

    const queryString = queryParams.toString();
    const url = `school/get_activation_requests${queryString ? `?${queryString}` : ""}`;

    const res = await http.get(url);
    return res;
  } catch (error) {
    return { data: { status: false, message: "Network Error: Could not connect to server" } };
  }
};

/* --------------------------------
   UPDATE ID CARD STATUS
   POST /api/school/update_id_card_status.php
-------------------------------- */
export const updateIdCardStatus = async (payload) => {
  try {
    const res = await http.post("school/update_id_card_status.php", payload);
    return res;
  } catch (error) {
    return { data: { status: false, message: "Network Error: Could not connect to server" } };
  }
};


